module.exports = __webpack_public_path__ + "img/confirm.3e8d0265.png";